
































import {Component, Vue, Prop} from 'vue-property-decorator'
import {SceneShot, Shot, StillShot, TitleShot, VideoShot} from '@/store/shots'
import ShotThumbnailImage from '@/components/VideoTimeline/ShotThumbnailImage.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {shotStore} from '@/store'

@Component({
  components: {ShotThumbnailImage, VuePerfectScrollbar}
})
export default class StoryboardItem extends Vue {
  @Prop() shot!: StillShot | VideoShot | SceneShot | TitleShot
  $refs!: {
    textarea: HTMLDivElement;
  }

  async onTextUpdate() {
    const proto = Object.getPrototypeOf(this.shot)
    // XXX: this is old & out of date. Should add the new shot in Vuex instead.
    const shot = new proto.constructor({...this.shot, storyboardText: this.$refs.textarea.innerText})
    await shotStore.saveShot(shot)
  }

  get storyboardText() {
    return this.shot.storyboardText
  }

  get thumbnailImageFile(): string {
    return Shot.getThumbnailImageFile(this.shot)
  }

  get shotTrimmedDuration(): number {
    return Shot.getTrimmedDurInSec(this.shot)
  }
}
